import { lazyLoad } from 'utils/loadable';

export const CoreHomePage = lazyLoad(
  () => import('./index'),
  module => module.CoreHomeByRoutePage,
);
